import { render, staticRenderFns } from "./DDataTable.vue?vue&type=template&id=062916bd&scoped=true&"
import script from "./DDataTable.vue?vue&type=script&lang=js&"
export * from "./DDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DDataTable.vue?vue&type=style&index=0&id=062916bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062916bd",
  null
  
)

export default component.exports